import { client, handleClientMethod } from "../client";
import type { ReviewQueueUpdateRequest } from "@onsemble/shared/types/internal";

export async function updateReviewQueue(
  id: string,
  data: ReviewQueueUpdateRequest
) {
  return handleClientMethod(
    client.PATCH("/api/internal/products/review-queue/{id}", {
      params: {
        path: { id },
      },
      body: data,
    })
  );
}
